// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1203":"b02e5f54a95aee19","9894":"83c35263b8ad96c3"}[chunkId] + ".js";
};